enum ViewerTypesEnum {
  VIDEO = 'VIDEO',
  IMAGE = 'IMAGE',
  PDF = 'PDF',
  IMAGE3D2D = 'IMAGE2D3D',
}

export { ViewerTypesEnum };
